"use client";
import Banner from "@/components/shared/banner";
import ContactForm from "@/components/shared/contactForm";
import ContactInfoBox from "@/components/shared/contactInfoBox";
import { useInfo } from "@/components/shared/infoProvider";
import useLocalizer from "@/hooks/useLocalizer";
import { Activity } from "react";

export default function ContactUsContent() {
  const { t } = useLocalizer();
  const { data: clientInfo } = useInfo();

  return (
    <section className="relative">
      <div className="relative h-80">
        <Banner
          breadcrumbItems={[
            {
              name: t("pages.contact"),
            },
          ]}
          title={t("pages.contact")}
          image="/images/backgrounds/contact-us.jpg"
        />
      </div>
      <div className="w-full h-full mb-20 mt-10 px-5 lg:px-0 ">
        <div className="container mx-auto grid lg:grid-cols-3 w-full gap-8">
          <ContactForm />
          <Activity mode={clientInfo ? "visible" : "hidden"}>
            <div className="lg:col-span-1">
              <ContactInfoBox
                data={{
                  client: clientInfo?.info,
                  socialMedia: clientInfo?.socialMedia,
                  periods: clientInfo?.periods,
                  covers: clientInfo?.covers,
                }}
              />
            </div>
          </Activity>
        </div>
      </div>
    </section>
  );
}
